export const RESPONSE_OVER_299 = 'Response Status is > 299'
export const CATCH_BLOCK_ERROR = 'Error caught in catch block'
export const NETWORK_ERROR = 'Network Error during fetch call'
export const INVALID_GQL_QUERY_RESPONSE = 'GraphQL query response is not as per contract'
export const GQL_QUERY_ERROR = 'GraphQL returned errors'
